import { createSelector } from "reselect";

import { displayCacheSelectors } from "../../../modules/display";

// TODO: This is implemented inefficiently right now, as we have to do a find on the displayItems...
// If we encounter issues, optimise with map or similar.
/**
 * @param {TimelineRecord} state
 * @param {string} typeId
 */
const getDisplayItemsOfType = createSelector(
  // inputs
  displayCacheSelectors.getDisplayItemsById,
  (state, typeId) => state.data.items.allIdsForType.get(typeId),
  // calculate based on inputs
  (displayItemMap, ids) => {
    return ids.map(id => displayItemMap.get(id));
  }
);

export default getDisplayItemsOfType;
